import { reactNode } from '@shared/node-v1.0.0'

import v010 from '@nodes/rich-text-v0.1.0'

export default reactNode(
	'RichText',
	{
		'v0.1.0': v010,
	},
	{ docs: '' }
)
